<template>

    <div class="container programaciones_wrapper">      
      <div class="tabla" v-if="estudiante">
        <b-button v-b-toggle.collapseHistorico variant="link"><h3>Historial</h3></b-button>

        <b-collapse id="collapseHistorico">
          <EstudianteEventos :estudiante="estudiante"/>
      </b-collapse>
      </div>
    </div>
  </template>
  
  <script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import EstudianteEventos from '@/components/Estudiantes/EstudianteEventos';
    export default {
      name: 'DetalleHistorico',
      components: {
        EstudianteEventos
      },
      data () {
        return {
        }
      },
      props: {
        estudiante: Object
      },
      mounted () {
        
        
      },
      methods:{
        ...mapActions({
        }),
        ...mapMutations({
          
        })
  
      },
      computed: {
        ...mapState({
          
        }),
        ...mapGetters({
        })
        
      }
    }
  </script>
  
  <style scope>
  
      .programaciones_wrapper .tabla{
        
      }
  </style>